import Lab1 from "./Lab1";

export default function Lab2() {
    return (
        <div>
            <h1>Labs</h1>
            <Lab1 />
            <h2>Lab 1</h2>
            <h2>Lab 3</h2>
        </div>
    )
}